import { render } from "./DigilamVsLitholamCosts.vue?vue&type=template&id=211978b2&scoped=true"
const script = {}

import "./DigilamVsLitholamCosts.vue?vue&type=style&index=0&id=211978b2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211978b2"]])

export default __exports__